import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html'
})
export class ComingSoonComponent {
  @Input() title = '';
  @Input() description = '';
}
